// Copyright © 2021 Move Closer

/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export enum LineHeaderTheme {
  Light = 'light',
  Dark = 'dark'
}

/**
 * This enum is needed for better TypeScript experience
 * within the `LineHeader.stories.ts` file.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export enum LineHeaderPropNames {
  IsBold = 'isBold',
  ShowPointer = 'showPointer',
  Site = 'site',
  Tag = 'tag',
  Theme = 'theme'
}
